import React, { useState } from 'react'
import styles from "./Works.module.css"
import img1 from "../../assets/website.png"
import mbs from "../../assets/mbs.png"
import img2 from "../../assets/ios.png"
import img3 from "../../assets/img3.png"
import ai from "../../assets/vbai.png"
import img4 from "../../assets/img4.png"
import WorkModel from './WorkModel'
function Works() {
    const [showModel, setShowModel] = useState("")
    const [active, setActive] = useState('Website')
    const [show1, setShow1] = useState('show')
    const [show2, setShow2] = useState('hide')
    const [show3, setShow3] = useState('hide')
    const [show4, setShow4] = useState('hide')
    const [show5, setShow5] = useState('hide')
    const [show6, setShow6] = useState('hide')
    const [show7, setShow7] = useState('hide')
    //console.log("show cclass", showModel)

    const handleShow = (e) => {
        //console.log(e)
    }
    return (
        <div className={styles.works}>
            <WorkModel show={showModel} />
            <h3 style={{ color: "#066263" }}>Work</h3>
            <div className={styles.worksTab}>
                <ul>
                    <li style={{ opacity: `${active === 'Website' ? "1" : "0.5"}` }} onMouseOver={(e) => { e.stopPropagation(); setActive('Website'); setShow1('show'); setShow2('hide'); setShow3('hide'); setShow4('hide'); setShow5('hide'); setShow6('hide'); setShow7('hide') }}>Website</li>
                    <li style={{ opacity: `${active === 'iOS' ? "1" : "0.5"}` }} onMouseOver={(e) => { e.stopPropagation(); setActive('iOS'); setShow1('hide'); setShow2('show'); setShow3('hide'); setShow4('hide'); setShow5('hide'); setShow6('hide'); setShow7('hide') }}>iOS</li>

                    <li style={{ opacity: `${active === 'Android' ? "1" : "0.5"}` }} onMouseOver={(e) => { e.stopPropagation(); setActive('Android'); setShow1('hide'); setShow2('hide'); setShow3('show'); setShow4('hide'); setShow5('hide'); setShow6('hide'); setShow7('hide') }}>Android</li>

                    <li style={{ opacity: `${active === 'AI Solution' ? "1" : "0.5"}` }} onMouseOver={(e) => { e.stopPropagation(); setActive('AI Solution'); setShow1('hide'); setShow2('hide'); setShow3('hide'); setShow4('show'); setShow5('hide'); setShow6('hide'); setShow7('hide') }}> AI Solution</li>

                    <li style={{ opacity: `${active === 'Web3.0' ? "1" : "0.5"}` }} onMouseOver={(e) => { e.stopPropagation(); setActive('Web3.0'); setShow1('hide'); setShow2('hide'); setShow3('hide'); setShow4('hide'); setShow5('show'); setShow6('hide'); setShow7('hide') }}>Web3.0</li>

                    <li style={{ opacity: `${active === 'Business Consulting' ? "1" : "0.5"}` }} onMouseOver={(e) => { e.stopPropagation(); setActive('Business Consulting'); setShow1('hide'); setShow2('hide'); setShow3('hide'); setShow4('hide'); setShow5('hide'); setShow6('show'); setShow7('hide') }}>Business Consulting</li>

                    <li style={{ opacity: `${active === 'Trading' ? "1" : "0.5"}` }} onMouseOver={(e) => { e.stopPropagation(); setActive('Trading'); setShow1('hide'); setShow2('hide'); setShow3('hide'); setShow4('hide'); setShow5('hide'); setShow6('hide'); setShow7('show') }}>Trading</li>
                </ul>
            </div>
            <div onMouseOver={(e) => e.stopPropagation()} className={styles.WorksSliderConatiner}>

                <div className={`${styles.workdGrid} ${show1}`}>
                    <div onClick={handleShow} className={`${styles.workdGridItem} ${styles.swingintopfwd}`}>
                        <div className={styles.workImg}>
                            <img src={img1} alt="" />
                        </div>
                        <div className={styles.WorkInfo}>
                            <p>Website / Concept make </p>
                            <h4>THE DECK</h4>
                            <p>大阪のコワーキングスペースである、THE DECKの新サービ <br /> スのLPのコンセプトメイク、デザイン。</p>
                        </div>
                    </div>
                    <div className={`${styles.workdGridItem} ${styles.swingintopfwd} ${styles.mobileView}`}>
                        <div className={styles.workImg}>
                            <img src={mbs} alt="" />
                        </div>
                        <div className={styles.WorkInfo}>
                            <p>Web Application </p>
                            <h4>M　B　S</h4>
                            <p>輸入中古車のオークションサービス。クライアントは、販売 <br /> 効率大幅に向上し、利益率も大幅に上がった。</p>
                        </div>
                    </div>
                    {/* <div className={`${styles.workdGridItem} ${styles.swingintopfwd} ${styles.mobileView}`}>
                        <div className={styles.workImg}>
                            <img src={img1} alt="" />
                        </div>
                        <div className={styles.WorkInfo}>
                            <p>Website / Concept make </p>
                            <h4>CLOUD Co.,Ltd.</h4>
                            <p>日本最大のタバコに関するウェブメディアの構築,とそのコンセプトの設計</p>
                        </div>
                    </div>
                    <div className={`${styles.workdGridItem} ${styles.swingintopfwd} ${styles.mobileView}`}>
                        <div className={styles.workImg}>
                            <img src={img1} alt="" />
                        </div>
                       <div className={styles.WorkInfo}>
                            <p>Website / Concept make </p>
                            <h4>CLOUD Co.,Ltd.</h4>
                            <p>日本最大のタバコに関するウェブメディアの構築,とそのコンセプトの設計</p>
                        </div>
                    </div> */}
                </div>
                <div className={`${styles.workdGrid2} ${show2}`}>
                    <div className={`${styles.workdGridItem} ${styles.swingintopfwd}`}>
                        <div className={styles.workImg}>
                            <img src={img2} alt="" />
                        </div>
                        <div className={styles.WorkInfo}>
                            <p>App Development</p>
                            <h4>Hillside</h4>
                            <p>実店舗もオンラインショップも持っていた小売店の専用アプ <br /> リを開発。物流,在庫管理も大幅に効率化実現。</p>
                        </div>
                    </div>
                    {/* <div className={`${styles.workdGridItem} ${styles.swingintopfwd} ${styles.mobileView}`}>
                        <div className={styles.workImg}>
                            <img src={img1} alt="" />
                        </div>
                        <div className={styles.WorkInfo}>
                            <p>Website / Concept make </p>
                            <h4>CLOUD Co.,Ltd.</h4>
                            <p>日本最大のタバコに関するウェブメディアの構築,とそのコンセプトの設計</p>
                        </div>
                    </div>
                    <div className={`${styles.workdGridItem} ${styles.swingintopfwd} ${styles.mobileView}`}>
                        <div className={styles.workImg}>
                            <img src={img1} alt="" />
                        </div>
                        <div className={styles.WorkInfo}>
                            <p>Website / Concept make </p>
                            <h4>CLOUD Co.,Ltd.</h4>
                            <p>日本最大のタバコに関するウェブメディアの構築,とそのコンセプトの設計</p>
                        </div>
                    </div>
                    <div className={`${styles.workdGridItem} ${styles.swingintopfwd} ${styles.mobileView}`}>
                        <div className={styles.workImg}>
                            <img src={img1} alt="" />
                        </div>
                        <div className={styles.WorkInfo}>
                            <p>Website / Concept make </p>
                            <h4>CLOUD Co.,Ltd.</h4>
                            <p>日本最大のタバコに関するウェブメディアの構築,とそのコンセプトの設計</p>
                        </div>
                    </div> */}
                </div>
                <div className={`${styles.workdGrid} ${show3}`}>
                    <div className={`${styles.workdGridItem} ${styles.swingintopfwd}`}>
                        <div className={styles.workImg}>
                            <img src={ai} alt="" />
                        </div>
                        <div className={styles.WorkInfo}>
                            <p>AI Solution </p>
                            <h4>CLOUD Co.,Ltd.</h4>
                            <p>表情をカメラで認識し、感情などを自動でAIが分析しデータ <br /> 化する高度な技術が求められるサービス。</p>
                        </div>
                    </div>
                    <div className={`${styles.workdGridItem} ${styles.swingintopfwd} ${styles.mobileView}`}>
                        <div className={styles.workImg}>
                            <img src={img1} alt="" />
                        </div>
                        <div className={styles.WorkInfo}>
                            <p>Website / Concept make </p>
                            <h4>CLOUD Co.,Ltd.</h4>
                            <p>日本最大のタバコに関するウェブメディアの構築,とそのコンセプトの設計</p>
                        </div>
                    </div>
                    <div className={`${styles.workdGridItem} ${styles.swingintopfwd} ${styles.mobileView}`}>
                        <div className={styles.workImg}>
                            <img src={img1} alt="" />
                        </div>
                        <div className={styles.WorkInfo}>
                            <p>Website / Concept make </p>
                            <h4>CLOUD Co.,Ltd.</h4>
                            <p>日本最大のタバコに関するウェブメディアの構築,とそのコンセプトの設計</p>
                        </div>
                    </div>
                    <div className={`${styles.workdGridItem} ${styles.swingintopfwd} ${styles.mobileView}`}>
                        <div className={styles.workImg}>
                            <img src={img1} alt="" />
                        </div>
                        <div className={styles.WorkInfo}>
                            <p>Website / Concept make </p>
                            <h4>CLOUD Co.,Ltd.</h4>
                            <p>日本最大のタバコに関するウェブメディアの構築,とそのコンセプトの設計</p>
                        </div>
                    </div>
                </div>
                <div className={`${styles.workdGrid} ${show4}`}>
                    <div className={`${styles.workdGridItem} ${styles.swingintopfwd}`}>
                        <div className={styles.workImg}>
                            <img src={ai} alt="" />
                        </div>
                        <div className={styles.WorkInfo}>
                            <p>AI Solution </p>
                            <h4>CLOUD Co.,Ltd.</h4>
                            <p>表情をカメラで認識し、感情などを自動でAIが分析しデータ <br /> 化する高度な技術が求められるサービス。</p>
                        </div>
                    </div>
                    <div className={`${styles.workdGridItem} ${styles.swingintopfwd} ${styles.mobileView}`}>
                        <div className={styles.workImg}>
                            <img src={img1} alt="" />
                        </div>
                        <div className={styles.WorkInfo}>
                            <p>Website / Concept make </p>
                            <h4>CLOUD Co.,Ltd.</h4>
                            <p>日本最大のタバコに関するウェブメディアの構築,とそのコンセプトの設計</p>
                        </div>
                    </div>
                    <div className={`${styles.workdGridItem} ${styles.swingintopfwd} ${styles.mobileView}`}>
                        <div className={styles.workImg}>
                            <img src={img1} alt="" />
                        </div>
                        <div className={styles.WorkInfo}>
                            <p>Website / Concept make </p>
                            <h4>CLOUD Co.,Ltd.</h4>
                            <p>日本最大のタバコに関するウェブメディアの構築,とそのコンセプトの設計</p>
                        </div>
                    </div>
                    <div className={`${styles.workdGridItem} ${styles.swingintopfwd} ${styles.mobileView}`}>
                        <div className={styles.workImg}>
                            <img src={img1} alt="" />
                        </div>
                        <div className={styles.WorkInfo}>
                            <p>Website / Concept make </p>
                            <h4>CLOUD Co.,Ltd.</h4>
                            <p>日本最大のタバコに関するウェブメディアの構築,とそのコンセプトの設計</p>
                        </div>
                    </div>
                </div>
                <div className={`${styles.workdGrid} ${show5}`}>
                    <div className={`${styles.workdGridItem} ${styles.swingintopfwd}`}>
                        <div className={styles.workImg}>
                            <img src={img1} alt="" />
                        </div>
                        <div className={styles.WorkInfo}>
                            <p>Website / Concept make </p>
                            <h4>CLOUD Co.,Ltd.</h4>
                            <p>日本最大のタバコに関するウェブメディアの構築,とそのコンセプトの設計</p>
                        </div>
                    </div>
                    <div className={`${styles.workdGridItem} ${styles.swingintopfwd} ${styles.mobileView}`}>
                        <div className={styles.workImg}>
                            <img src={img1} alt="" />
                        </div>
                        <div className={styles.WorkInfo}>
                            <p>Website / Concept make </p>
                            <h4>CLOUD Co.,Ltd.</h4>
                            <p>日本最大のタバコに関するウェブメディアの構築,とそのコンセプトの設計</p>
                        </div>
                    </div>
                    <div className={`${styles.workdGridItem} ${styles.swingintopfwd} ${styles.mobileView}`}>
                        <div className={styles.workImg}>
                            <img src={img1} alt="" />
                        </div>
                        <div className={styles.WorkInfo}>
                            <p>Website / Concept make </p>
                            <h4>CLOUD Co.,Ltd.</h4>
                            <p>日本最大のタバコに関するウェブメディアの構築,とそのコンセプトの設計</p>
                        </div>
                    </div>
                    <div className={`${styles.workdGridItem} ${styles.swingintopfwd} ${styles.mobileView}`}>
                        <div className={styles.workImg}>
                            <img src={img1} alt="" />
                        </div>
                        <div className={styles.WorkInfo}>
                            <p>Website / Concept make </p>
                            <h4>CLOUD Co.,Ltd.</h4>
                            <p>日本最大のタバコに関するウェブメディアの構築,とそのコンセプトの設計</p>
                        </div>
                    </div>
                </div>
                <div className={`${styles.workdGrid} ${show6}`}>
                    <div className={`${styles.workdGridItem} ${styles.swingintopfwd}`}>
                        <div className={styles.workImg}>
                            <img src={img2} alt="" />
                        </div>
                        <div className={styles.WorkInfo}>
                            <p>Website / Concept make </p>
                            <h4>CLOUD Co.,Ltd.</h4>
                            <p>日本最大のタバコに関するウェブメディアの構築,とそのコンセプトの設計</p>
                        </div>
                    </div>
                    <div className={`${styles.workdGridItem} ${styles.swingintopfwd} ${styles.mobileView}`}>
                        <div className={styles.workImg}>
                            <img src={img1} alt="" />
                        </div>
                        <div className={styles.WorkInfo}>
                            <p>Website / Concept make </p>
                            <h4>CLOUD Co.,Ltd.</h4>
                            <p>日本最大のタバコに関するウェブメディアの構築,とそのコンセプトの設計</p>
                        </div>
                    </div>
                    <div className={`${styles.workdGridItem} ${styles.swingintopfwd} ${styles.mobileView}`}>
                        <div className={styles.workImg}>
                            <img src={img1} alt="" />
                        </div>
                        <div className={styles.WorkInfo}>
                            <p>Website / Concept make </p>
                            <h4>CLOUD Co.,Ltd.</h4>
                            <p>日本最大のタバコに関するウェブメディアの構築,とそのコンセプトの設計</p>
                        </div>
                    </div>
                    <div className={`${styles.workdGridItem} ${styles.swingintopfwd} ${styles.mobileView}`}>
                        <div className={styles.workImg}>
                            <img src={img1} alt="" />
                        </div>
                        <div className={styles.WorkInfo}>
                            <p>Website / Concept make </p>
                            <h4>CLOUD Co.,Ltd.</h4>
                            <p>日本最大のタバコに関するウェブメディアの構築,とそのコンセプトの設計</p>
                        </div>
                    </div>
                </div>
                <div className={`${styles.workdGrid} ${show7}`}>
                    <div className={`${styles.workdGridItem} ${styles.swingintopfwd}`}>
                        <div className={styles.workImg}>
                            <img src={img3} alt="" />
                        </div>
                        <div className={styles.WorkInfo}>
                            <p>Website / Concept make </p>
                            <h4>CLOUD Co.,Ltd.</h4>
                            <p>日本最大のタバコに関するウェブメディアの構築,とそのコンセプトの設計</p>
                        </div>
                    </div>
                    <div className={`${styles.workdGridItem} ${styles.swingintopfwd} ${styles.mobileView}`}>
                        <div className={styles.workImg}>
                            <img src={img1} alt="" />
                        </div>
                        <div className={styles.WorkInfo}>
                            <p>Website / Concept make </p>
                            <h4>CLOUD Co.,Ltd.</h4>
                            <p>日本最大のタバコに関するウェブメディアの構築,とそのコンセプトの設計</p>
                        </div>
                    </div>
                    <div className={`${styles.workdGridItem} ${styles.swingintopfwd} ${styles.mobileView}`}>
                        <div className={styles.workImg}>
                            <img src={img1} alt="" />
                        </div>
                        <div className={styles.WorkInfo}>
                            <p>Website / Concept make </p>
                            <h4>CLOUD Co.,Ltd.</h4>
                            <p>日本最大のタバコに関するウェブメディアの構築,とそのコンセプトの設計</p>
                        </div>
                    </div>
                    <div className={`${styles.workdGridItem} ${styles.swingintopfwd} ${styles.mobileView}`}>
                        <div className={styles.workImg}>
                            <img src={img1} alt="" />
                        </div>
                        <div className={styles.WorkInfo}>
                            <p>Website / Concept make </p>
                            <h4>CLOUD Co.,Ltd.</h4>
                            <p>日本最大のタバコに関するウェブメディアの構築,とそのコンセプトの設計</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Works